// src/pages/ClientArea.js
import React from 'react';
import './ClientArea.css';

const ClientArea = () => {
  return (
    <div className="container">
      <h1 className="title">Área do Cliente</h1>
      <p className="description">
        Acesse sua conta para monitorar seu veículo em tempo real, consultar contratos e muito mais.
      </p>
      <a href="https://g3.rastrosystem.com.br/acl/login/?next=/" className="button" target="_blank" rel="noopener noreferrer">
        Acessar Área do Cliente
      </a>
    </div>
  );
};

export default ClientArea;